export const ISSUE_ASSIGNED_EVENT = 'avi:jira:assigned:issue' as const;
export const ISSUE_CREATED_EVENT = 'avi:jira:created:issue' as const;
export const ISSUE_DELETED_EVENT = 'avi:jira:deleted:issue' as const;
export const ISSUE_TRANSITIONED_EVENT = 'avi:jira:transitioned:issue' as const;
export const ISSUE_UPDATED_EVENT = 'avi:jira:updated:issue' as const;
export const ISSUE_COMMENTED_EVENT = 'avi:jira:commented:issue' as const;
export const ISSUE_MENTIONED_EVENT = 'avi:jira:mentioned:issue' as const;
export const ISSUE_PARENT_ASSOCIATION_EVENT = 'avi:jira:updated:issue_parent_association' as const;

export const SUBSCRIPTION_SUPPORTED_EVENTS: Set<string> = new Set([
	ISSUE_CREATED_EVENT,
	ISSUE_DELETED_EVENT,
	ISSUE_UPDATED_EVENT,
	ISSUE_COMMENTED_EVENT,
	ISSUE_MENTIONED_EVENT,
	ISSUE_PARENT_ASSOCIATION_EVENT,
]);
